import React from 'react';
import { useParams } from 'react-router-dom';

import SurveyInstanceDetail from '@totem/components/surveyV2/instanceDetail/SurveyInstanceDetail';
import NaSurveyContainer from '@totem/components/unauthenticated/surveys/instance/naSurveyContainer';

const NaSurveyPage = () => {
  const { id } = useParams();

  return (
    <NaSurveyContainer token={id}>
      <SurveyInstanceDetail />
    </NaSurveyContainer>
  );
};

export default NaSurveyPage;
